import { useState, useCallback } from 'react';

const STORAGE_KEY = 'wantd_tile_size';
const MIN_TILE_SIZE = 150;
const MAX_TILE_SIZE = 300;
const DEFAULT_TILE_SIZE = 200;

function clamp(value) {
  return Math.min(MAX_TILE_SIZE, Math.max(MIN_TILE_SIZE, value));
}

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw !== null) return clamp(Number(raw));
  } catch { /* private browsing / quota */ }
  return DEFAULT_TILE_SIZE;
}

export function useTileSize() {
  const [tileSize, setTileSizeRaw] = useState(readStored);

  const setTileSize = useCallback((value) => {
    const clamped = clamp(value);
    setTileSizeRaw(clamped);
    try { localStorage.setItem(STORAGE_KEY, String(clamped)); } catch { /* noop */ }
  }, []);

  const gridStyle = {
    display: 'grid',
    // Cap the minimum column width at 50vw - 1.5rem so very narrow viewports
    // (e.g. Galaxy Fold front screen ~260px) always fit at least 2 columns and
    // never produce columns wider than the viewport.
    gridTemplateColumns: `repeat(auto-fill, minmax(min(${tileSize}px, calc(50vw - 1.5rem)), 1fr))`,
    gap: tileSize <= 180 ? '0.5rem' : '0.75rem',
  };

  return { tileSize, setTileSize, gridStyle, MIN_TILE_SIZE, MAX_TILE_SIZE };
}
